import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { Table, TableModule } from "primeng/table";
import { BcRevenueTransactionsData } from "../../../../core/models/bcLedgers/BcRevenueTransactionsResponseDto";
import { GetProjectInvoiceReportRequestDto } from "../../../../core/models/orders/getProjectInvoiceReportRequestDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { exportExcel } from "../../../../core/services/shared.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";

@Component({
  selector: "jni-bc-revenue-transactions",
  templateUrl: "./bc-revenue-transactions.component.html",
  styleUrls: ["./bc-revenue-transactions.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    ModalStackerComponent,
    ButtonModule,
    InputTextModule,
    ClientDetailsComponent,
  ],
})
export class BcRevenueTransactionsComponent implements OnChanges {
  @Input() bcRevenueLists!: BcRevenueTransactionsData[];
  @Input() TotalBCRevenue!: number;
  @Input() TotalBCGP!: number;
  @Input() BCAvgMargin!: number;
  @Input() TotalBCCommission!: number;
  @Input() TotalBCReserve!: number;
  @Input() saleOrderId = "";
  @Input() salesOrderNumberFilter = false;
  orderDisplayModal = false;
  fileName = "BC Revenue Transaction";
  clientDisplayModal = false;
  customerId = "";
  @ViewChild("dt") dt!: Table;
  @Output() closeModalEvent = new EventEmitter();

  constructor(
    private _router: Router,
    private _loaderService: LoaderService,
    private _orderSummary: OrderSummaryService,
    private _toastr: JniToastrService,
    private renderer: Renderer2,
    private _dashboardService: DashboardService
  ) {}

  ngOnChanges() {
    if (this.dt.filters && this.salesOrderNumberFilter) {
      this.dt.filters["SalesOrderNumber"] = [
        { value: "4", matchMode: "notContains", operator: "and" },
      ];
    }
  }

  clearTable(table: Table) {
    table.clear();
  }

  exportExcelFile() {
    exportExcel(this.bcRevenueLists, this.fileName);
  }

  redirectToSummary(saleOrderId: string) {
    this._router.navigate(["orders/order-summary/" + saleOrderId]);
  }

  redirectToInvoice(invoiceNumber: string) {
    //this.getProjectInvoiceReport(invoiceNumber, invoiceDate);
    this._loaderService.setLoaderState(true);
    this._dashboardService.getInvoiceReport(invoiceNumber).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (!res.data) {
          this._toastr.error("Error", res.message);
          return;
        }
        const blob = this.b64toBlob(res.data, "application/pdf");
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  redirectToClientSummary(clientId: string) {
    this.customerId = clientId;
    this.clientDisplayModal = true;
    //  this._router.navigate(['clients/active/client-details/' + clientId]);
  }

  getProjectInvoiceReport(invoiceNumber: string, invoiceDate: string) {
    this._loaderService.setLoaderState(true);
    const reportObject = {
      InvoiceDate: invoiceDate,
      ProjectInvoiceId: invoiceNumber,
    } as GetProjectInvoiceReportRequestDto;
    this._orderSummary.getProjectInvoiceReport(reportObject).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.data?.reportBase64String) {
          const blob = this.b64toBlob(
            res.data.reportBase64String,
            "application/pdf"
          );
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        } else {
          this._toastr.error("Error", res.message);
          return;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  closeModal() {
    this.clientDisplayModal = false;
  }

  closeModalOnRedirection() {
    this.clientDisplayModal = false;
  }

  addScollHiddenClass() {
    //if (this.modal) {
    this.renderer.addClass(document.body, "p-overflow-hidden");

    //}
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
